import { render, staticRenderFns } from "./StatisticsAdmin.vue?vue&type=template&id=57bf7469&"
import script from "./StatisticsAdmin.vue?vue&type=script&lang=js&"
export * from "./StatisticsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports